import { toMoment } from '@core/utils/time';
import { CommissionPeriod, CommissionInvoiceType } from '@business/entities/commission';
import { CommissionConfigFormData } from '@modules/settings/SettingsPage/Components/CommissionSettingsTab/CommissionConfigTab';

export function getAllPeriods() {
  return [CommissionPeriod.weekly, CommissionPeriod.biweekly, CommissionPeriod.bimonthly, CommissionPeriod.monthly];
}

export function getPeriodTitle(period: CommissionPeriod) {
  switch (period) {
    case CommissionPeriod.weekly:
      return 'Weekly (Runs every week)';
    case CommissionPeriod.biweekly:
      return 'Bi-Weekly (Runs every 2 weeks)';
    case CommissionPeriod.bimonthly:
      return 'Bi-Monthly (Runs twice a month)';
    case CommissionPeriod.monthly:
      return 'Monthly (Runs once a month)';
  }
}

/** "Salesman Fee" for the rule dropdown; a fee already named "... Fee" keeps its name ("Referral Fee"). */
export function getFeeLabel(name: string) {
  const trimmed = name.trim();
  return trimmed.toLowerCase().endsWith('fee') ? trimmed : `${trimmed} Fee`;
}

export function getAllInvoiceType() {
  return [CommissionInvoiceType.all, CommissionInvoiceType.recurring, CommissionInvoiceType.nonRecurring];
}

export function getInvoiceTypeTitle(type: CommissionInvoiceType) {
  switch (type) {
    case CommissionInvoiceType.all:
      return 'All';
    case CommissionInvoiceType.recurring:
      return 'Recurring';
    case CommissionInvoiceType.nonRecurring:
      return 'Non-Recurring';
  }
}

export function getCurrentPeriod(formValue: CommissionConfigFormData, dateObj?: boolean) {
  let start = toMoment();
  let end = toMoment();
  switch (formValue.period) {
    case CommissionPeriod.weekly:
      end = start
        .clone()
        .day(formValue.day || 0)
        .subtract(formValue.cutoff || 0, 'days');
      start = end.clone().subtract(1, 'week').add(1, 'day');
      break;
    case CommissionPeriod.biweekly:
      end = start
        .clone()
        .day(formValue.day || 0)
        .add(formValue.firstWeekOfYear ? 0 : 7, 'days')
        .subtract(formValue.cutoff || 0, 'days');
      start = end.clone().subtract(2, 'week').add(1, 'day');
      break;
    case CommissionPeriod.bimonthly:
      const day1 = formValue.day || 1;
      const day2 = formValue.dayTwo || 15;
      const currentDay = toMoment().date();
      if (currentDay > day2) {
        start = start.clone().date(day2).add(1, 'day');
        end = start.clone().add(1, 'month').date(day1);
      } else {
        start = start.clone().date(day1).add(1, 'day');
        end = start.clone().date(day2);
      }
      start = start.subtract(formValue.cutoff || 0, 'days');
      end = end.subtract(formValue.cutoff || 0, 'days');

      break;
    case CommissionPeriod.monthly:
      if (formValue.day === 99) {
        start = start.startOf('month');
        end = start.clone().endOf('month');
      } else {
        start = toMoment()
          .date(formValue.day || 1)
          .subtract(formValue.cutoff || 0, 'days')
          .add(1, 'day');
        end = start.clone().add(1, 'month');
      }
      break;
  }

  if (dateObj) {
    return {
      start,
      end,
    };
  }

  return `${start.format('ddd MMM DD, YYYY')} - ${end.format('ddd MMM DD, YYYY')}`;
}
